// extracted by mini-css-extract-plugin
export var details = "project-details-module--details--1tNzN";
export var header = "project-details-module--header--3k4_e";
export var btn = "project-details-module--btn--7VszR";
export var featured = "project-details-module--featured--3OUDF";
export var html = "project-details-module--html--3YwDw";